import { GridColDef } from '@mui/x-data-grid'
import { ColumnDate, ColumnLink } from '~/shared/ui/AsyncGrid'
import { GridRow } from './types'

export const columns: GridColDef<GridRow>[] = [
  {
    field: 'id',
    headerName: 'ID',
    minWidth: 200,
    sortable: false,
    renderCell: ({ row }) => <ColumnLink to={row.id}>{row.id}</ColumnLink>,
  },
  {
    field: 'code',
    headerName: 'Промо-код',
    minWidth: 200,
    sortable: false,
    renderCell: ({ row }) => <ColumnLink to={row.id}>{row.code}</ColumnLink>,
  },
  {
    field: 'title',
    headerName: 'Название',
    minWidth: 200,
    sortable: false,
    renderCell: ({ row }) => <ColumnLink to={row.id}>{row.title}</ColumnLink>,
  },
  {
    field: 'description',
    headerName: 'Описание',
    minWidth: 250,
    sortable: false,
    renderCell: ({ row }) => (
      <ColumnLink to={row.id}>{row.description}</ColumnLink>
    ),
  },
  {
    field: 'usagesLeft',
    headerName: 'Количество использований',
    minWidth: 220,
    sortable: false,
    renderCell: ({ row }) => (
      <ColumnLink to={row.id}>{row.usagesLeft}</ColumnLink>
    ),
  },
  {
    field: 'beginningAt',
    headerName: 'Дата начала',
    minWidth: 200,
    sortable: false,
    renderCell: ({ value }) => <ColumnDate type='date' value={value} />,
  },
  {
    field: 'expiredAt',
    headerName: 'Дата окончания',
    minWidth: 200,
    sortable: false,
    renderCell: ({ value }) => <ColumnDate type='date' value={value} />,
  },
]
